import { useState } from "react";
import { IonTextarea } from "@ionic/react";
import { Asterisk } from "swing-components";

import { Toggle } from "~components/Molecules/Toggle/Toggle";
import { translate } from "~utils";

type AdditionalEditProps = {
  hasAdditionalEdits: boolean;
  additionalEditMemo: string;
  setHasAdditionalEdits: (e: boolean) => void;
  setAdditionalEditMemo: (e: string) => void;
};

export const AdditionalEditField: React.FC<AdditionalEditProps> = ({
  hasAdditionalEdits,
  additionalEditMemo,
  setHasAdditionalEdits,
  setAdditionalEditMemo,
}) => {
  const [temporaryMemo, setTemporaryMemo] = useState(additionalEditMemo);
  const onCheckboxChange = (checked: boolean) => {
    setAdditionalEditMemo(checked ? temporaryMemo : "");
    setHasAdditionalEdits(checked);
  };

  const onInputChange = (e: CustomEvent) => {
    setTemporaryMemo(e.detail.value);
    setAdditionalEditMemo(e.detail.value);
  };

  return (
    <div css={{ marginBottom: 16 }}>
      <Toggle
        label={translate("EDIT_REQUEST_ADDITIONAL_EDITS_LABEL")}
        isSelected={hasAdditionalEdits}
        onToggleChange={onCheckboxChange}
        aria-label="Enable this to add additional edits to the request"
      />
      {hasAdditionalEdits && (
        <div css={{ paddingTop: 16 }}>
          <p css={{ margin: 0 }}>
            {translate("EDIT_REQUEST_ADDITIONAL_EDITS_HEADER")}
            <Asterisk />
          </p>
          <IonTextarea
            autoGrow
            value={additionalEditMemo}
            onIonInput={onInputChange}
            debounce={100}
            placeholder={translate("EDIT_REQUEST_ADDITIONAL_EDITS_PLACEHOLDER")}
          />
        </div>
      )}
    </div>
  );
};
